import { networkManagementEndPoints } from '@src/apps/constants/apiUrlConstants';
import { SITE_SERVICE_URL } from '@src/CommonComponents/constant/api_url_constants';
import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { getContractIdValuesFromSession } from '@src/CommonComponents/ContractIdFilter/contractIdFilter';
const _httpService = new HttpService();
if(checkIsInternal()){
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}
else{
 _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
 //_httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}

export const getSosData= async (payload:any) =>{
    try {
                     const requestPayload = sessionStorage.getItem('contractIdNavigation') === 'true'
                         ? {
                                 ...payload,
                                 ContractIds: getContractIdValuesFromSession(),
                             }
                         : payload;
                     if (sessionStorage.getItem('contractIdNavigation') === 'true') {
                         delete requestPayload.Tins;
                         delete requestPayload.ProviderSysKey;
                     }
                     const responseData: any = await _httpService.push(SITE_SERVICE_URL, requestPayload);
                return responseData;
            } catch {
                return null;
            }
  }

  export const getMarketSharedData= async (payload:any) =>{
    try {
           const responseData: any = await _httpService.push(networkManagementEndPoints.affordabilitySOSDetailsPage, payload);
                return responseData;
            } catch {
                return null;
            }
  }


